var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-inner"},[_c('h1',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.block.options.title ? _vm.block.options.title : _vm.block.acf_fc_layout)))]),_vm._v(" "),_c('pre',{staticClass:"bg-gray-light rounded-md p-4"},[_vm._v(_vm._s(_vm.block))])])
}
var staticRenderFns = []

export { render, staticRenderFns }